// import React from "react";

// const OurMission = () => {
//   return (
//     <section className="relative md:h-[calc(100vh-70px)] flex items-center justify-center overflow-hidden bg-gray-900">
//       {/* Background Image */}
//       <div className="absolute inset-0 z-0">
//         <div className="absolute inset-0 bg-black opacity-50"></div>
//         <div
//           className="w-full h-full bg-cover bg-center"
//           style={{
//             backgroundImage:
//               "url('https://res.cloudinary.com/dxdvcplbl/image/upload/v1755018361/DJI_20250811180135_0086_D-min_ps6pt8.jpg')",
//           }}
//         ></div>
//       </div>

//       {/* Mission Content */}
//       <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
//         <div className="bg-opacity-70 p-10 md:p-14 rounded-lg backdrop-blur-[1px]">
//           <h2 className="text-3xl md:text-5xl font-bold text-white mb-8">
//             Our Mission
//           </h2>

//           <div className="space-y-6">
//             <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
//               "To provide an exceptional golfing experience by combining
//               world-class facilities, a welcoming community, and a commitment to
//               excellence — both on and off the course."
//             </p>
//             <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
//               "We strive to make our club a destination where passion for the
//               game meets unparalleled service and hospitality."
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default OurMission;

import React, { useState } from "react";

const OurMission = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="text-gray-800 font-sans">
      {/* Mission Content Section */}
      <section className="py-16 px-4 md:px-20 bg-white grid md:grid-cols-2 gap-10">
        <img
          src="https://res.cloudinary.com/dxdvcplbl/image/upload/v1754842635/DJI_20250810155002_0040_D-min_yyib3k.jpg"
          alt="Golf Course"
          className="w-full h-auto rounded-lg"
        />
        <div>
          <h2 className="text-xl font-bold mb-4">Our Mission</h2>
          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out ${
              isExpanded ? "max-h-[1000px]" : "max-h-[6em]"
            }`}
          >
            <p className="mb-4">
              "To promote golf by providing a worldclass, serene, and inclusive
              environment, fostering sportsmanship, camaraderie, and excellence
              among our members and guests while preserving the natural beauty
              of our surroundings."
            </p>
          </div>
          {/* <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-black mt-4 text-sm underline hover:text-black/70 transition-colors duration-300"
          >
            {isExpanded ? "READ LESS" : "READ MORE"}
          </button> */}
        </div>
      </section>
    </div>
  );
};

export default OurMission;
